/* ──────────────────────────────────────────────────────────────
   src/hooks/useFormatos.ts
   Devuelve el catálogo completo de formatos
   (id, nombreFormato)                       – React-Query flavour
   ────────────────────────────────────────────────────────────── */
import { useQuery } from "@tanstack/react-query";
import api from "../api/axios";

export interface Formato {
  id: number;
  nombreFormato: string;
}

export function useFormatos() {
  const { data = [], isFetching: loading } = useQuery({
    queryKey: ["formatos"],
    queryFn: async () => {
      const { data } = await api.get("/formatos");
      /* el backend trae { id, nombreFormato }                     */
      return (data ?? []).map((f: any) => ({
        id: f.id,
        nombreFormato: f.nombreFormato ?? f.nombre, // por si cambia el backend
      })) as Formato[];
    },
  });

  return { rows: data, loading };
}
